export default function ReformatNumber(stringNumber: any): number {
    if (stringNumber === null || stringNumber === undefined || stringNumber === '') return 0;

    const s = String(stringNumber).trim().replace(/[\s\u00a0\u202f]+/g, '');
    if (!s) return 0;

    const lastDot = s.lastIndexOf('.');
    const lastComma = s.lastIndexOf(',');
    const lastSep = Math.max(lastDot, lastComma);

    if (lastSep === -1) {
        const n = Number(s);
        return isNaN(n) ? 0 : n;
    }

    const intPart = s.substring(0, lastSep).replace(/[.,]/g, '');
    const decPart = s.substring(lastSep + 1);
    const n = Number(intPart + '.' + decPart);
    return isNaN(n) ? 0 : n;
}